export interface Props {
  color: string;
  size?: number;
}
const BookSvg = () => {
  return (
    <svg
      width="29"
      height="21"
      viewBox="0 0 29 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.0886 3.46232H26.4223V2.20852C26.4223 1.97485 26.2829 1.76377 26.068 1.672C22.5491 0.169842 18.2197 0.806487 14.6718 3.32285C11.1241 0.806487 6.79453 0.17002 3.27575 1.672C3.0608 1.76377 2.9214 1.97485 2.9214 2.20852V3.46232H1.2552C0.933086 3.46232 0.671875 3.72347 0.671875 4.04564V20.1692C0.671875 20.4914 0.933086 20.7525 1.2552 20.7525H14.6719H28.0886C28.4107 20.7525 28.6719 20.4913 28.6719 20.1692V4.0457C28.6719 3.72353 28.4107 3.46232 28.0886 3.46232ZM1.83852 19.5859V4.62902H2.9214V18.3321C2.9214 18.528 3.01981 18.7108 3.18326 18.8188C3.34678 18.9268 3.55348 18.9454 3.73371 18.8685C6.46608 17.7021 9.76578 17.9938 12.6945 19.5859H1.83852ZM14.0886 19.0538C11.9596 17.6971 9.59124 16.9927 7.30516 16.9927C6.20149 16.9927 5.11713 17.1569 4.08811 17.4911V4.05245C4.08811 4.05014 4.08847 4.04795 4.08847 4.0457C4.08847 4.04345 4.08817 4.0412 4.08811 4.03894V2.60309C7.19947 1.43691 10.9722 2.08908 14.0886 4.33985V19.0538ZM15.2552 4.33985C18.3716 2.08902 22.1445 1.43691 25.2557 2.60309V4.03889C25.2557 4.04114 25.2553 4.04339 25.2553 4.04564C25.2553 4.04789 25.2556 4.05014 25.2557 4.05239V17.491C22.0951 16.4644 18.412 17.0422 15.2552 19.0538V4.33985ZM27.5052 19.5859H16.6492C19.578 17.9938 22.8776 17.7022 25.61 18.8685C25.7903 18.9455 25.9971 18.9268 26.1605 18.8188C26.324 18.7108 26.4223 18.528 26.4223 18.3321V4.62902H27.5052V19.5859Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default BookSvg;
